import 'react';

export interface StructuredDataProps {
    type: 'Product';
    name: string;
    images : string[];
    description: string;
    sku: string;
    mpn: string;
    brand: SDBrand,
    digitalProduct?: SDProduct[]
}

interface SDBrand {
    '@type': 'Brand',
    name: string;
}

interface SDProduct {
    '@type': 'Offer',
    priceCurrency: 'USD',
    price: number,
    itemCondition: 'https://schema.org/NewCondition',
    availability: 'https://schema.org/InStock',
}

export function StructuredData(props: StructuredDataProps): JSX.Element{

    const obj = {
        "@context": "https://schema.org/",
        "@type": props.type,
        "name" : props.name,
        "image" : props.images,
        "description" : props.description,
        "sku": props.sku,
        "mpn": props.mpn,
        "brand" : props.brand,
        "offers": props.digitalProduct
    }

    return(<script type="application/ld+json">{JSON.stringify(obj)}</script>);
}
